import React, { ReactElement, ComponentType } from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'

function withConfirm<P extends React.JSX.IntrinsicAttributes>(
  title: string,
  contentText: string,
  open: boolean,
  onCancel: (a: any) => any,
  onConfirm?: (a: any) => any,
  WrappedComponent?: ComponentType<P>,
): (props: P) => ReactElement {
  return function WithDialog(props: P): ReactElement {
    return (
      <Dialog onClose={onCancel} open={open}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          {contentText && <DialogContentText>{contentText}</DialogContentText>}
          {WrappedComponent && <WrappedComponent {...props} />}
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color="primary">
            Cancel
          </Button>
          <Button
            onClick={onConfirm ?? (props as any).onConfirm}
            color="primary"
            variant="contained"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withConfirm
